import { render } from "./FornitoriMenu.vue?vue&type=template&id=48044954&ts=true"
import script from "./FornitoriMenu.vue?vue&type=script&lang=ts"
export * from "./FornitoriMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__